import { render } from "./PaymentReceiptDetail.vue?vue&type=template&id=76c8d941&scoped=true"
import script from "./PaymentReceiptDetail.vue?vue&type=script&lang=js"
export * from "./PaymentReceiptDetail.vue?vue&type=script&lang=js"

import "./PaymentReceiptDetail.vue?vue&type=style&index=0&id=76c8d941&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76c8d941"]])

export default __exports__